export default __webpack_public_path__ + "static/media/kbis-logo.1d0a5fa6.svg";